(function () {

    'use strict';

    angular.module('Services').service('PopLockerProvidersLocationTable', PopLockerProvidersLocationTable);

    PopLockerProvidersLocationTable.$inject = [
        'PopLockerService',
        'TableLiteFactory',
        '$location',
        'ConfirmationModalFactory',
        'toastr'
    ];

    function PopLockerProvidersLocationTable(
        PopLockerService,
        TableLiteFactory,
        $location,
        ConfirmationModalFactory,
        toastr,
        $uibModal
    ) {
        return function () {
            const deleteConfirmationModal = new ConfirmationModalFactory({}, {
                message: 'messages.warning.deletePopLockerProvider.MESSAGE',
                code: 'messages.warning.deletePopLockerProvider.CODE'
            });

            const tableData = {
                tableName: 'popLockerProvidersTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add Location',
                        tooltip: 'Click to add new pop locker provider.',
                        onClick: function () {
                            // $location.path('/carriers/pop-lockers/add');
                        }
                    }, {
                        class: 'btn-primary',
                        label: 'Import Location ',
                        tooltip: 'Click to add new pop locker provider.',
                        onClick: function () {
                            $location.path('/carriers/pop-lockers/add');
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [
                    {
                        label: 'SELECT',
                        class: 'text-center',
                        filter: {
                            type: 'checkbox'
                        }
                    },
                    {
                        label: 'Locker ID',
                        viewName: 'lockerId',
                        width: '100px',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Location Name',
                        viewName: 'locationName',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Location Address',
                        viewName: 'locatioAddress',
                        // width: '100px',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Drop-off/PickUp',
                        viewName: 'lockerLocationType',
                        // width: '100px',
                        filter: {
                            type: 'select2',
                            placeholder: 'Select Status',
                            items: ['Pick Up', 'Drop-off'],
                            onSelect: function (header) {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Operating hours',
                        viewName: 'order',
                        // width: '100px',
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Status',
                        viewName: 'status',
                        width: '100px',
                        filterName: 'active',
                        filter: {
                            type: 'select2',
                            placeholder: 'Select Status',
                            items: ['Enabled', 'Disabled'],
                            onSelect: function (header) {
                                let filter = {};
                                if (header.filter.model == 'Enabled') {
                                    filter[header.filterName] = true;
                                } else {
                                    filter[header.filterName] = false;
                                }
                                sendRequest(filter);
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Actions',
                        viewName: 'actions',
                        width: '200px'
                    }
                ],
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: PopLockerService.getLocation,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc',
                    filterType: 'all'
                }
            });

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                if (!data) { return null; }

                angular.forEach(data.content, function (row) {



                    row.locatioAddress = {
                        type: 'multiLine',
                        list: [
                            row.addressLine1 || undefined,
                            row.addressLine2 || undefined,
                            `${angular.getObjVal(row, 'location.name')}, ` +
                            `${angular.getObjVal(row, 'location.state.code') || angular.getObjVal(row, 'location.state.name')}` +
                            `${angular.getObjVal(row, 'location.code') ? '-' + angular.getObjVal(row, 'location.code') : ''}, ` +
                            `${angular.getObjVal(row, 'location.country.code')}`
                        ]
                    };
                    row.status = {
                        type: 'status',
                        status: row.active,
                        label: row.active ? 'Enable' : 'Disable'
                    }
                    row.actions = buildButtons(row);
                    row.href = `/carriers/pop-lockers/${row.id}`; // todo: add implementation code here
                    tableData.data.push(row);
                });
            }

            function buildButtons(data) {
                return {
                    type: 'button',
                    buttons: [addStatusButtons(data), {
                        text: 'Delete',
                        class: 'btn btn-danger',
                        action: function (row) {
                            deleteProvider(row);
                        }
                    }]
                }
            }

            function addStatusButtons(data) {
                if (data.active) {
                    return {
                        text: 'Disable',
                        class: 'btn btn-default',
                        action: function (row) {
                            updateProviderStatus(row);
                        }
                    }
                }
                return {
                    text: 'Enable',
                    class: 'btn btn-green',
                    action: function (row) {
                        updateProviderStatus(row);
                    }
                }
            }

            function updateProviderStatus(data) {
                data.active = !data.active;
                const payload = PopLockerService.payloadMapper(data);
                PopLockerService.updateById(data.id, success => {
                    toastr.success('Pop locker provider successfully updated.', 'Success');
                    sendRequest();
                }, error => {
                    toastr.error(error.message, 'Error');
                }, payload);
            }

            function deleteProvider(data) {
                deleteConfirmationModal.getInstance().result.then(cond => {
                    if (cond) {
                        PopLockerService.delete(data.id, success => {
                            sendRequest();
                            toastr.success('Pop locker provider successfully deleted.', 'Success');
                        }, error => {
                            toastr.error(error.message, "Error");
                        });
                    }
                });
            }

            this.tableData = tableData;
        }

        function locationModal() {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/pages/accounting/modals/issue-credit-note-modal.html',
                controller: 'IssueCreditNoteModalController',
                controllerAs: 'vm',
                windowClass: 'full-height-modal',
                size: 'lg',
                appendTo: $('body'),
                resolve: {
                    shipments: () => {
                        return selectedShipments;
                    },
                    invoiceData: () => {
                        return vm.data;
                    }
                }
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/pop-lockers/PopLockerProvidersLocationTable.js